<template>
    <div class="article-box-wrapper">
        <router-link :to="articleUrl" class="article-image-wrapper" v-lazyload :style="{backgroundImage: `url('${article.imgUrl}')`}">

            <div class="article-title-container-mobile">
                <div class="article-title-mobile">{{article.title}}</div>
                <div class="article-date-mobile" v-if="!isGiftList">{{article.date | formatDateCustom('MMM DD, YYYY')}}</div>
            </div>


        </router-link>
        <div class="article-details">
            <div class="article-details-title">
                <router-link :to="articleUrl" class="article-title">{{article.title}}</router-link>
            </div>
            <div class="article-details-desc">
                <div class="article-desc">{{article.desc}}</div>                
                <div class="article-button">
                    <router-link :to="articleUrl" class="button-link">
                        <button class="button button-explore">Explore</button>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ArticleBox',
        props: ['article'],
        data() {
            return {
                articleUrl: null,
                isGiftList: false
            }
        },
        created() {
            this.init();
        },
        methods: {
            init() {

                if (this.$route.name == 'giftideas' || this.article.isGiftList) {
                    this.isGiftList = true;
                    this.articleUrl = '/gift-ideas/' + this.article.articleId + '/' + this.article.prettyTitle;
                }
                else {
                    this.isGiftList = false;
                    this.articleUrl = '/Blog/' + this.article.articleId + '/' + this.article.prettyTitle;
                }
            }
        }
    }
</script>
